export default "__VITE_ASSET__DFgjbcnH__"